// extracted by mini-css-extract-plugin
export var teamWrapper = "Team-module--team-wrapper--1bQUk";
export var teamMember = "Team-module--team-member--1B1bC";
export var teamMember__fullName = "Team-module--team-member__full-name--3xI-i";
export var teamMember__role = "Team-module--team-member__role--3qfr4";
export var teamMember__description = "Team-module--team-member__description--16xLm";